import React from "react";
import {
  BooleanField,
  ChipField,
  DateField,
  FunctionField,
  ReferenceArrayField,
  ReferenceField,
  Show,
  SimpleShowLayout,
  SingleFieldList,
  TextField,
} from "react-admin";
import { CircleOutlined, ErrorOutline } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import MuiLink from "@mui/material/Link";

const errorStyle = (record: any) => ({
  padding: "0.5em",
  backgroundColor: record?.failed ? "#f99" : record?.error ? "#fee" : "default",
});

const InvoiceExportShow = () => {
  return (
    <Show>
      <SimpleShowLayout>
        <ReferenceField source="customerId" reference="Customer" link="show">
          <TextField source="name" />
        </ReferenceField>

        <FunctionField
          source="invoiceNumber"
          render={(record: any) => {
            return record?.sevDeskInvoiceId ? (
              <MuiLink
                href={`https://my.sevdesk.de/fi/detail/type/RE/id/${record.sevDeskInvoiceId}`}
                style={{
                  textDecoration: "none",
                }}
              >
                {record.invoiceNumber}
              </MuiLink>
            ) : (
              record?.invoiceNumber
            );
          }}
        />

        <ReferenceArrayField
          source="serviceBookingIds"
          reference="ServiceBooking"
        >
          <SingleFieldList>
            <ChipField source="serviceTemplate.name" />
          </SingleFieldList>
        </ReferenceArrayField>

        <BooleanField
          source="failed"
          FalseIcon={CircleOutlined}
          TrueIcon={ErrorOutline}
          textAlign="center"
        />
        <FunctionField
          source="error"
          render={(record: any) => {
            return record.error ? (
              <Typography style={errorStyle(record)}>{record.error}</Typography>
            ) : null;
          }}
        />

        <DateField source="createdAt" />
      </SimpleShowLayout>
    </Show>
  );
};
export default InvoiceExportShow;
